import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from 'src/store'
import { handleRedirectByState } from 'src/useCase/keepFlow'
import { USER_TREATMENT_STATE } from 'src/enum/userTreatmentState'
import { updatePlanSelection } from 'src/useCase/userTreatment'
import { PATH as PATH_AUTOMATIC_PLAN } from 'src/pages/automaticPlan'
import { PATH as PATH_VIDEO } from 'src/pages/video'

export default function useHandleTreatmentRedirect() {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const user = useAppSelector((state) => state.ui.app.authInfo)

  const handleRedirect = useCallback(
    async (userTreatment: any, buildQuery: string = '') => {
      if (!userTreatment) return

      const { state, menu_id, id } = userTreatment

      if (state === USER_TREATMENT_STATE.SELECTED_TREATMENT) {
        return navigate(
          `${PATH_AUTOMATIC_PLAN.QUESTIONS.replace(
            ':id',
            String(menu_id),
          )}?${buildQuery}`,
        )
      }

      if (state === USER_TREATMENT_STATE.REGISTERED_INTERVIEW) {
        if (!user?.phone || (!user?.otp_expire_at && !user?.otp_verified_at)) {
          return navigate(
            `${PATH_AUTOMATIC_PLAN.PHONE_VERIFICATION}?menu_id=${menu_id}&${buildQuery}`,
          )
        }
        const updatedTreatment = await dispatch(
          updatePlanSelection({ id }),
        ).unwrap()
        // Use the updated treatment state for subsequent redirection
        const nextPath = handleRedirectByState(updatedTreatment, user, {})
        if (nextPath && nextPath !== 'popup') {
          return navigate(`${nextPath}?${buildQuery}`)
        }
        return nextPath
      }

      if (state === USER_TREATMENT_STATE.VIDEO_INTERVIEW_SCHEDULED) {
        navigate(`${PATH_VIDEO.VIDEO_SCHEDULE}?${buildQuery}`)
        return
      }

      const path = handleRedirectByState(userTreatment, user, {})
      if (path && path !== 'popup') {
        navigate(`${path}?${buildQuery}`)
        return
      }

      return path
    },
    [navigate, dispatch, user],
  )

  return { handleRedirect }
}
